/*
 * @Descripttion: input输入框（区间类型）
 * @Author: yang chenglin
 * @LastEditors: yang chenglin
 */
import React, { useState } from 'react';
import { DatePicker } from '@alifd/next';
import moment from 'moment';
import styles from './index.module.scss';

/**
 * opType 在dayType数组范围内
 * @param changeData-把组件的值提交到父组件，改变父组件的值
 * @param tagItem-整个标签的信息
 */
const TagTime = ({
  tagItem = {}, changeData = (data) => {
  },
}) => {
  const [data, setData] = useState(tagItem.opValue?.extra_map?.date ?? ['', '']); // 区间的值更改前或后面的值适合用数组形式改变，所以自己内部维护一个数组

  /**
   * @description: 计算被禁用的时间范围
   * @param {*}
   * @return {*}
   */
  const currentDate = moment();
  const disabledDate = (date) => {
    return (date.valueOf() > currentDate.valueOf()); // 时间大于今天或者超出了禁用范围，不可选
  };

  /**
   * 选择时改变也要处理成数组形式
   */
  const changeValue = ({ opValue, index }) => {
    if (opValue && Number(opValue) > 0) {
      const arr = [...data];
      arr[index] = opValue.toString();
      setData(arr);
      changeData({
        opValue: {
          label_id: tagItem?.id,
          extra_map: {
            date: arr,
          },
        },
        opType: 'RANGE'
      });
    } else if (!opValue) {
      const arr = [...data];
      arr[index] = '';
      setData(arr);
      changeData({
        opValue: {
          label_id: tagItem?.id,
          extra_map: {
            date: arr,
          },
        },
        opType: 'RANGE'
      });
    }
  };

  return (
    <div className={`${styles['tag-Time']} tag-width`}>
      <DatePicker
        style={{ width: '170px' }}
        followTrigger
        disabledDate={disabledDate}
        value={data[0] ? moment(Number(data[0])).format('YYYY-MM-DD') : ''}
        onChange={(val) => changeValue({ opValue: moment(val).startOf('day').valueOf(), index: 0 })}
      />
      <span> -- </span>
      <DatePicker
        style={{ width: '170px' }}
        followTrigger
        disabledDate={disabledDate}
        value={data[1] ? moment(Number(data[1])).format('YYYY-MM-DD') : ''}
        onChange={(val) => changeValue({ opValue: moment(val).endOf('day').valueOf(), index: 1 })}
      />
      {
        !data.every((item) => {
          return item.toString().length > 0;
        }) && <div style={{ color: "#f33", marginTop: "5px" }}
          className={`iconfont icon-icon4-30 ${styles['tag-error-select']}`}
        >请选择{tagItem.labelDescription}
        </div>
      }
    </div>
  );
};
export default TagTime;
